const userRoles = user => user && user.role && user.role.id;

export const userHasRole = (user, role) => user && userRoles(user) && userRoles(user) === role;



// WEBPACK FOOTER //
// ./src/utils/roles.js